import { MESSAGE_SET_MESSAGE, MESSAGE_HIDE_MESSAGE } from '../actions/constants'
import { AlertProps } from 'react-bootstrap/Alert'
import { MessageActions } from '../actions/message'

export interface IMessage {
  message: string
  type: AlertProps['variant']
  show: boolean
}

const MESSAGE_INITIAL_STATE: IMessage = {
  message: '',
  type: 'success',
  show: false,
}

export const message = (
  state: IMessage = MESSAGE_INITIAL_STATE,
  action: MessageActions
) => {
  switch (action.type) {
    case MESSAGE_SET_MESSAGE:
      return {
        ...state,
        ...MESSAGE_INITIAL_STATE,
        ...action.payload,
        show: true,
      }
    case MESSAGE_HIDE_MESSAGE:
      return MESSAGE_INITIAL_STATE
    default:
      return state
  }
}
